module.exports = __webpack_public_path__ + "static/7-11909ed26478574d0ded570a203892ce.jpg";